import React from 'react';
import styles from './Spinner.module.sass';

const Spinner = ({
  className
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: `${styles['spinner']} ${className || ''}`
  });
};

export default Spinner;